export const BREAKPOINT_LARGE = 1060;
export const BREAKPOINT_MED = 768;
export const PAGE_MAX_WIDTH = 1600;
export let HTML_WIDTH = window.innerWidth;

window.addEventListener('resize', () => HTML_WIDTH = window.innerWidth);
